import { Button, Modal } from '@paysera/ui';
import { Trans, useTranslation } from 'react-i18next';
import { getUserLocale } from '@app/utils/getUserLocale';
const TerminateLoan = ({ closeModal, isOpen, loanId }) => {
    const { t } = useTranslation();
    const locale = getUserLocale();
    const sendTerminationEmail = () => {
        const recipientEmail = locale === 'lt' ? 'pagalba@paysera.lt' : 'support@paysera.com';
        const subject = t('financing.terminate_loan.email_subject', { id: loanId });
        window.location.href = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}`;
    };
    return (<Modal open={isOpen} size="md" onClose={closeModal} heading={t('financing.terminate_loan.title')} footer={<div className="flex md:flex-row justify-end flex-col gap-2">
                    <Button onClick={closeModal} variant="tertiary" size="md" label={t('financing.terminate_loan.close_button')}/>
                    <Button onClick={sendTerminationEmail} variant="critical" size="md" label={t('financing.terminate_loan.send_email_button')}/>
                </div>}>
            <p className="text-neutral-secondary-initial body-m mb-6">
                {t('financing.terminate_loan.cancel_within_2_days')}
            </p>
            <p className="text-neutral-secondary-initial body-m">
                {t('financing.terminate_loan.cancel_within_14_days')}
            </p>
            <ul className="list-disc list-inside text-neutral-secondary-initial body-m mb-6">
                <li>{t('financing.terminate_loan.interest_accrued')}</li>
                <li>{t('financing.terminate_loan.non_refundable_fees')}</li>
            </ul>
            <p className="text-neutral-secondary-initial body-m">
                <Trans i18nKey="financing.terminate_loan.contact_support" components={{
            lithuaniaEmailLink: <a href="mailto:pagalba@paysera.lt">pagalba@paysera.lt</a>,
            otherCountriesEmailLink: <a href="mailto:support@paysera.com">support@paysera.com</a>,
        }}/>
            </p>
        </Modal>);
};
export default TerminateLoan;
